/**
 * Runs `task`, retrying it up to `attempts - 1` more times when it throws.
 * The last error is rethrown.
 */
export async function retry<T>(task: () => Promise<T>, attempts = 2): Promise<T> {
  let lastError: unknown;
  for (let i = 0; i < attempts; i += 1) {
    try {
      return await task();
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError;
}
